import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { EpubBg } from '../../assets';
import AssetViewer from './AssetViewer';
import { RootState } from '../../store';
import DQBIcon from '../../assets/images/DQBIcon.svg';

import LPIcon from '../../assets/images/LPIcon.svg';
import ActivitiesComponent from '../activities/ActivitiesComponent';
import ToggleComponent from '../common/ToggleButton';
import PageChangeButtons from './PageNavigatorComponent';
import Select from '../common/Select';
import { setCDNCookies } from '../../utils/cdnUtil';
import ZoomPopup from './HotspotViewer';
import { extractHotspots, getInitialPage, getTOC } from '../../helper';
import {
    goToPage,
    goTOPageHref,
    handlePageChange,
} from '../../utils/readiumUtils';
import { setTOCOpen } from '../../features/TOC/TOCOpenSlice';
import TOC from '../TOC/TOC';
import CloseIcon from '../../assets/images/closeIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useGetBookByIdMutation } from '../../api/books';
import {
    setCurrentBookId,
    setCurrentBookName,
    setCurrentClassId,
    setCurrentIsbn,
    setCurrentSubjectId,
    setPage,
} from '../../features/currentBook/currentBookSlice';

import { setActiveTab } from '../../features/toggle/toggleSlice';
import { notification, Tooltip } from 'antd';
import FullScreenModal from '../common/FullScreenModal';
import { useGetBookmarksQuery } from '../../api/bookmark';
import { setBookmarks } from '../../features/bookMark/bookMarkSlice';
import { useGetNotesQuery } from '../../api/note';
import { setNotes } from '../../features/notes/noteSlice';
import { setHighlights } from '../../features/highlights/highlightsSlice';
import { useGetHighlightsQuery } from '../../api/highlights';
import { trackEvent } from '../../segment';
import { setLPOpen } from '../../features/LP/LPOpenSlice';
import LP from '../LessonPlan/LP';
import { setWidgetOpen } from '../../features/Widget/WidgetOpenSlice';
import Widget from '../Widget/Widget';
import Evaluate from '../Evaluate/Evaluate';
import {
    setOfflineModalOpen,
    setSideNavIconClickedName,
} from '../../features/offlineModal/offlineModalSlice';
import { NoInternetModal } from '../common/NoInternetModal';
import { setDQBOpen } from '../../features/DQB/DQBOpenSlice';
import DQB from '../DQB/DQB';
import { setWidgetModalOpen } from '../../features/widgetModal/WidgetModalOpenSlice';
import { useOpenDqbMutation } from '../../api/open-dqb';
// import { LPElement } from '../../types/LPElement';
import { useGetLessonPlanQuery } from '../../api/lessonPlan';
import { useGetResourceConfigQuery } from '../../api/resourceConfig';
import { setResourceConfig } from '../../features/resourceConfig/resourceConfigSlice';
import MediaPlayerHandler from '../players/MediaPlayerHandler';
import TransparentModal from '../common/TransparentModal';
import { setLpPdfPlayerpen } from '../../features/LpPdfPlayer/LpPdfPlayerSlice';
import EvaluateIcon from '../../assets/images/EvaluateIcon.svg';
import { setEvaluateOpen } from '../../features/Evaluate/EvaluateOpenSlice';
import { setEvaluateMediaHandler } from '../../features/EvaluatePdfPlayer/EvaluatePdfPlayerSlice';
import { useGetEvaluateQuery } from '../../api/evaluate';
import { UserPreference } from '../../config';
import { useGetCTRBQuery } from '../../api/ctrb';
import { setCTRBMediaHandler } from '../../features/CTRBPdfPlayer/CTRBPdfPlayerSlice';
interface Asset {
    href: string;
    title?: string;
    mediaType: string;
    mediaTitle: string;
    resTitle: string;
    resId: string;
}
interface ResourceConfigItem {
    res_type: string;
    displayName: string;
    icon: string;
    visibleToRoles: string[];
    visibleToProducts: string[];
    action: {
        default: string;
    };
    action_when_file_not_found: {
        default: string;
    };
    modal?: {
        buttonText: string;
        description: string;
        link: string;
        showRedirectButton: boolean;
        title: string;
    };
}

interface ResourceConfigData {
    resourceConfig: ResourceConfigItem[];
}

interface ResourceConfigResponse {
    success: boolean;
    data: ResourceConfigData;
}

const options = [
    { value: 'all_assets', label: 'All Assets' },
    { value: 'all_videos', label: 'All Videos' },
];

const BookReader: React.FC = () => {
    const shouldNavigateToUrlPage = useRef(true);

    const [className, setClassName] = useState<string>('');
    const [subjectName, setSubjectName] = useState<string>('');
    const [bookUri, setBookUri] = useState<string>('');
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedActivity, setSelectedActivity] = useState<Asset | null>(
        null
    );
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const initialPage = Number(params.get('page')) || getInitialPage();
    const [currentPage, setCurrentPage] = useState<number>(initialPage);

    const [selectedResType, setSelectedResType] = useState<string | string>(
        options[0].value
    );
    const product = useSelector((state: RootState) => state.product);
    const productType = useSelector(
        (state: RootState) => state.SchoolInfo.data.product
    );
    const installationPackage = useSelector(
        (state: RootState) =>
            state.SchoolInfo.data.installation_package?.INSTALLATION_MODE
    );
    const dispatch = useDispatch();
    const { data: resource_config_data, isError: resource_config_error } =
        useGetResourceConfigQuery(productType) as {
            data: ResourceConfigResponse | null;
            isError: boolean;
        };
    if (resource_config_data?.success) {
        localStorage.setItem(
            'resourceConfigData',
            JSON.stringify(resource_config_data?.data?.resourceConfig)
        );
        dispatch(setResourceConfig(resource_config_data));
    }

    const [isTourDone, setIsTourDone] = useState(false);
    const [zoomData, setZoomData] = useState<{
        zoomId: string;
        title: string;
        content: string;
        book_uri: string;
    } | null>(null);
    const activeTab = useSelector((state: RootState) => state.toggle.activeTab);
    const [ZoomPageData, setZoomPageData] = useState<any>([]);
    const [offset, setOffset] = useState<number>(0);
    const [isIframeLoaded, setIsFrameLoaded] = useState(false);
    const isopenToc = useSelector(
        (state: { TOCOpen: { isOpen: boolean } }) => state.TOCOpen.isOpen
    );
    const isopenLP = useSelector(
        (state: { LPOpen: { isOpen: boolean } }) => state.LPOpen.isOpen
    );
    const isopenWidget = useSelector(
        (state: { WidgetOpen: { isOpen: boolean } }) => state.WidgetOpen.isOpen
    );
    const isopenEvaluate = useSelector(
        (state: { EvaluateOpen: { isOpen: boolean } }) =>
            state.EvaluateOpen.isOpen
    );
    const isWidgetModalOpen = useSelector(
        (state: RootState) => state.WidgetModalOpen.isOpen
    );
    const widgetUrl = useSelector(
        (state: RootState) => state.WidgetModalOpen.url
    );
    const isOpenDQB = useSelector((state: RootState) => state.DQBOpen.isOpen);
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [noInternetModalOpen, setNoInternetModalOpen] = useState(true);
    const [
        getOpenDqb,
        { isLoading: isDqbOpenLoading, isError: isDqbOpenError },
    ] = useOpenDqbMutation();
    // const [lp, setLP] = useState<LPElement[]>([]);

    // Get the showDQB preference value
    const [showDQBPreference, setShowDQBPreference] =
        useState<string>('When required');

    useEffect(() => {
        // Load user preferences
        const userPreference = UserPreference.getInstance();
        userPreference.load().then(() => {
            const showDQBValue = userPreference.getValue<string>('showDQB');
            if (showDQBValue) {
                setShowDQBPreference(showDQBValue);
            }
        });
    }, []);

    // Event listener for online status change
    const handleOnline = () => {
        setIsOnline(true);
    };

    // Event listener for offline status change
    const handleOffline = () => {
        setIsOnline(false);
    };
    useEffect(() => {
        setIsOnline(navigator.onLine);
    }, [isOnline]);
    const EvaluateClickHanlder = () => {
        trackEvent('click_evaluate', {});
        dispatch(setActiveTab('openBook'));
        dispatch(setEvaluateOpen(true));
    };
    const CTRBClickHanlder = () => {
        trackEvent('click_CTRB', {});
        dispatch(setActiveTab('openBook'));
        dispatch(setCTRBMediaHandler({
            isOpen: true,
            url: ctrbData.data.url,
            title: ctrbData?.data?.name ?? "",
            resource_id: ctrbData?.data?.resource_id,
            resource_type: "pdf" 
        }))
    };
    const TOCclickHandler = () => {
        dispatch(setActiveTab('openBook'));
        dispatch(setTOCOpen(!isopenToc));
        trackEvent('click_toc', {});
    };
    const LPclickHandler = () => {
        trackEvent('click_lesson_plan', {});
        dispatch(setActiveTab('openBook'));
        if (isOnline) {
            dispatch(setLPOpen(true));
        } else {
            dispatch(setOfflineModalOpen(true));
            dispatch(setSideNavIconClickedName('Lesson Plan'));
        }
    };

    const [bookData, setBookData] = useState<any>();
    const [handleARI, setHandleARI] = useState({ url: '', mediaType: '' });
    const [bookId, setBookId] = useState<string>('');
    const [getBookById, { isLoading, isError }] = useGetBookByIdMutation();
    const { data: allBookMarks = [] } = useGetBookmarksQuery(bookId, {
        skip: !bookId,
    });
    const { data: lessonPlan } = useGetLessonPlanQuery(bookId, {
        skip: !bookId,
    });
    const { data: evaluateData } = useGetEvaluateQuery(
        { book_id: bookId, product_type: productType },
        {
            skip: !bookId,
        }
    );
    const { data: ctrbData }:any = useGetCTRBQuery(
            { book_id: bookId },
            {
                skip: !bookId,
            }
        );

    const { data: allNotes = [] } = useGetNotesQuery(bookId, {
        skip: !bookId,
    });
    const { data: allAnnotations = { data: [] } } = useGetHighlightsQuery<any>(
        bookId,
        { skip: !bookId }
    );
    const evaluatePdfPlayerData = useSelector(
        (state: RootState) => state.evaluatePdfPlayer
    );
    const CTRBPdfPlayerData = useSelector(
        (state: RootState) => state.CTRBPdfPlayer
    );
    const isLpPdfPlayerOpen = useSelector(
        (state: RootState) => state.lpPdfPlayer.isOpen
    );
    const lpPdfPlayerUrl = useSelector(
        (state: RootState) => state.lpPdfPlayer.url
    );
    const lpPdfPlayerResType = useSelector(
        (state: RootState) => state.lpPdfPlayer.resource_type
    );
    const lpPlayerResId = useSelector(
        (state: RootState) => state.lpPdfPlayer.resource_id
    );

    const lpPdfPlayerTitle = useSelector(
        (state: RootState) => state.lpPdfPlayer.resource_title
    );

    const [assetViewerSource, setAssetViewerSource] = useState('');
    const handleDQBClick = () => {
        trackEvent('click_dqb', {});
        dispatch(setDQBOpen(false));
        getOpenDqb({ book_id: bookId })
            .unwrap() // This ensures we get the result of the mutation (or an error)
            .then((response: any) => {
                // Handle successful launch response
                console.log('DQB successful:', response);
            })
            .catch((error: any) => {
                // Handle error
                console.error('DQB failed:', error);
            });
    };

    useEffect(() => {}, [noInternetModalOpen]);
    useEffect(() => {
        // Add event listeners when the component is mounted
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // Clean up the event listeners when the component is unmounted
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);
    useEffect(() => {
        if (activeTab == 'assets') {
            //old event
            trackEvent('epub_assets_clicked', {
                class_id: bookData?.classid,
                book_id: bookData?.bookId,
            });
        }
    }, [activeTab]);
    useEffect(() => {
        dispatch(setBookmarks(allBookMarks?.data));
    }, [allBookMarks, bookId]);
    useEffect(() => {}, [widgetUrl, isWidgetModalOpen]);

    useEffect(() => {
        dispatch(setNotes(allNotes?.data));
    }, [allNotes, bookId]);
    useEffect(() => {
        dispatch(setHighlights(allAnnotations?.data));
    }, [allAnnotations, bookId]);
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const book_id = queryParams.get('bookId') || '';
        const isbn = queryParams.get('isbn') || '';
        setBookId(book_id);
        getBookById({ bookId: book_id, isbn: isbn }).then((res) => {
            setBookData(res?.data?.data);
        });
    }, [location.search]);

    useEffect(() => {
        if (bookData) {
            setOffset(bookData?.bookdetails?.offsetpagenumber);
            dispatch(setCurrentBookName({ name: bookData?.bookdetails?.name }));
            dispatch(setCurrentBookId(bookData?.bookdetails?.id));
            dispatch(setCurrentClassId(bookData?.classid));
            dispatch(setCurrentSubjectId(bookData?.subjectid));
            dispatch(setCurrentIsbn(bookData?.isbns[0]?.isbn));
            setClassName(bookData.classname);
            setSubjectName(bookData.bookdetails.name);
            setIsTourDone(
                localStorage.getItem(
                    `${bookData.subjectname}-${bookData.classname}-demo`
                ) === 'true'
            );
            if (bookData?.bookdetails?.url) {
                setBookUri(bookData.bookdetails.url);
                extractHotspots(bookData?.bookdetails?.url).then((res: any) => {
                    setZoomPageData(res);
                    updateOffset(bookData?.bookdetails?.url);
                });
            }
        }
    }, [bookData]);

    useEffect(() => {
        const handleActivityClick = (event: MessageEvent) => {
            if (event.data.type === 'assetClick') {
                if (event.data.actionType === 'activityClick') {
                    if (event.data?.asset?.mediaType == 'buildr')
                        //old event
                        trackEvent('redirection_to_lab_from_epub', {
                            res_type: event.data?.asset?.mediaType,
                            res_id: event.data.asset?.resId,
                            res_title: event.data.asset?.resTitle,
                            source: 'bottom drawer',
                        });
                    else {
                        //old event
                        trackEvent('bottom_drawer_resource_played', {
                            res_type: event.data?.asset?.mediaType,
                            res_id: event.data.asset?.resId,
                            res_title: event.data.asset?.resTitle,
                            source: 'bottom drawer',
                        });
                    }
                    setAssetViewerSource('bottom drawer');
                } else {
                    if (event.data?.asset?.mediaType == 'buildr') {
                        //old event
                        trackEvent('redirection_to_lab_from_epub', {
                            res_type: event.data?.asset?.mediaType,
                            res_id: event.data.asset?.resId,
                            res_title: event.data.asset?.resTitle,
                            source: 'epub icon of buildr',
                        });
                    } else {
                        //old event
                        trackEvent('epub_resources_played', {
                            res_type: event.data?.asset?.mediaType,
                            res_id: event.data.asset?.resId,
                            res_title: event.data.asset?.resTitle,
                            source: 'epub icon of buildr',
                        });
                    }
                    setAssetViewerSource('epub icon');
                }

                setSelectedActivity(event.data.asset);

                if (event.data.asset?.resId) setIsPopupOpen(true);
                else {
                    notification.info({
                        message: 'Info',
                        description: 'Resource id not found',
                        duration: 3, // Duration in seconds before the notification closes
                    });
                }
            } else if (event.data.type === 'pageChange') {
                const pageNumber = event.data.pageNumber;
                //
                const newPage = +pageNumber?.slice(4) || currentPage || 0;

                // Only update if page actually changed or not first render of book reader
                if (
                    newPage !== currentPage &&
                    !shouldNavigateToUrlPage.current
                ) {
                    setCurrentPage(newPage);
                    dispatch(setPage({ currentPage: newPage }));

                    // Update URL params
                    const newParams = new URLSearchParams(location.search);
                    newParams.set('page', newPage.toString());
                    navigate(`${location.pathname}?${newParams.toString()}`, {
                        replace: true,
                    });
                }
                //
                const eventName = event.data.eventName;
                const gotoCurrPage = event.data.currentPageNum;
                if (!eventName) return; //early return if event name is not found
                if (pageNumber !== currentPage) {
                    setCurrentPage(pageNumber);
                }
                const pageNumStr = pageNumber?.slice(4) ?? '';
                const xhtml_page = Number(pageNumStr) || 0;
                const current_page = Number(pageNumStr) - offset || 0;

                dispatch(setPage({ currentPage: current_page }));

                const isPrev = eventName === 'click_previous_page';

                const eventPayload = {
                    curr_page:
                        eventName === 'click_goto_page'
                            ? +gotoCurrPage
                            : xhtml_page,
                    next_page: isPrev ? xhtml_page - 1 : xhtml_page + 1,
                };

                trackEvent(eventName, eventPayload);
            } else if (event.data.type === 'bookmark') {
                const pageNumber = event.data.page_no;
                trackEvent('click_bookmark', { page_num: pageNumber - offset });
            } else if (event.data.type === 'unbookmark') {
                const pageNumber = event.data.page_no;
                trackEvent('click_unbookmark', { page_num: pageNumber });
            } else if (event.data.type === 'iframeLoaded') {
                setIsFrameLoaded(true);
                if (shouldNavigateToUrlPage.current) {
                    const urlPage = Number(params.get('page'));
                    goToPage(window, urlPage);
                    setCurrentPage(urlPage);
                    dispatch(setPage({ currentPage: urlPage }));
                    shouldNavigateToUrlPage.current = false;
                }
            }
        };

        window.addEventListener('message', handleActivityClick);
        return () => {
            window.removeEventListener('message', handleActivityClick);
        };
    }, [bookUri, activeTab, currentPage, location, navigate, dispatch]);

    const updateOffset = async (bookUri: string) => {
        const res = await getTOC(bookUri);
        let initialOffset = parseInt(bookData?.bookdetails.offset_page_number);

        if (isNaN(initialOffset) && res.length > 0) {
            const firstPageMatch = res[0].href.match(/page(\d+)\.xhtml/);
            initialOffset = firstPageMatch
                ? parseInt(firstPageMatch[1], 10)
                : 0;
        }
        // setOffset(initialOffset - 1);
    };

    const closePopup = (pageNo?: string) => {
        setIsPopupOpen(false);
        setZoomData(null);
        if (pageNo !== undefined) {
            const page = parseInt(pageNo.match(/\d+/)?.[0] || '0', 10);

            goTOPageHref(window, pageNo);
            handlePageChange(window);
        }
        setSelectedActivity(null);
        setHandleARI({ url: '', mediaType: '' });
        setCDNCookies({});
        dispatch(setLpPdfPlayerpen(false));
        dispatch(
            setEvaluateMediaHandler({
                isOpen: false,
                url: '',
                resource_id: '',
                resource_type: '',
                resource_title: '',
            })
        );
        dispatch(
            setCTRBMediaHandler({
            isOpen: false,
            url: "",
            title: "",
            resource_id: "",
            resource_type: "" 
        }));
    };
    const current_book = useSelector(
        (state: RootState) => state.currentBook.name
    );
    const handleClassChange = (value: string | string[]) => {
        if (value === 'all_videos') {
            //old event
            trackEvent('epub_all_videos_clicked', {
                book_title: current_book,
            });

            trackEvent('dropdown_all_videos_clicked', {});
        }
        if (value === 'all_assets') {
            //old event
            trackEvent('epub_all_assets_clicked', {
                book_title: current_book,
            });
            trackEvent('dropdown_all_assets_clicked', {});
        }
        if (Array.isArray(value)) {
            setSelectedResType(value.join(', '));
        } else {
            setSelectedResType(value);
        }
    };

    const redirectToJasper = () => {
        // TODO: Redirect to Jasper
    };
    const iframeSrc = `/epub-reader/readium/index.html?epub=${bookUri}&userRole=student`;
    return (
        <>
            {isLpPdfPlayerOpen && (
                <TransparentModal
                    title={lpPdfPlayerTitle}
                    isOpen={isLpPdfPlayerOpen}
                    completeUrl={lpPdfPlayerUrl}
                    onClose={() => closePopup()}
                >
                    <div className="flex flex-col justify-center items-center w-full h-auto">
                        <MediaPlayerHandler
                            type={lpPdfPlayerResType}
                            resId={lpPlayerResId}
                            completeUrl={lpPdfPlayerUrl}
                        />
                    </div>
                </TransparentModal>
            )}
            {evaluatePdfPlayerData.isOpen && (
                <TransparentModal
                    title={evaluatePdfPlayerData.resource_title}
                    isOpen={evaluatePdfPlayerData.isOpen}
                    completeUrl={evaluatePdfPlayerData.url}
                    onClose={() => closePopup()}
                >
                    <div className="flex flex-col justify-center items-center w-full h-auto">
                        <MediaPlayerHandler
                            type={evaluatePdfPlayerData.resource_type}
                            resId={evaluatePdfPlayerData.resource_id}
                            completeUrl={evaluatePdfPlayerData.url}
                            bookId={bookId}
                        />
                    </div>
                </TransparentModal>
            )}
            {CTRBPdfPlayerData.isOpen && (
                <TransparentModal
                    title={CTRBPdfPlayerData.title}
                    isOpen={CTRBPdfPlayerData.isOpen}
                    completeUrl={CTRBPdfPlayerData.url}
                    onClose={() => closePopup()}
                >
                    <div className="flex flex-col justify-center items-center w-full h-auto">
                        <MediaPlayerHandler
                            type={CTRBPdfPlayerData.resource_type}
                            resId={CTRBPdfPlayerData.resource_id}
                            completeUrl={CTRBPdfPlayerData.url}
                        />
                    </div>
                </TransparentModal>
            )}
            {isopenToc && bookUri && <TOC bookUri={bookUri} offset={offset} />}
            {isopenLP && bookUri && (
                <LP
                    bookUri={bookUri}
                    bookId={bookId}
                    offset={offset}
                    lp={lessonPlan}
                />
            )}
            {isopenWidget && bookId && <Widget bookId={bookId} />}
            {isopenEvaluate && bookUri && bookId && (
                <Evaluate evaluateData={evaluateData} />
            )}
            {isOpenDQB && bookId && <DQB bookId={bookId} />}
            {isWidgetModalOpen && widgetUrl && (
                <>
                    <FullScreenModal
                        isOpen={isWidgetModalOpen}
                        onClose={() => {
                            dispatch(setWidgetModalOpen(false));
                        }}
                    >
                        <MediaPlayerHandler
                            type="articulate"
                            resId={''}
                            bookId={bookId}
                            completeUrl={widgetUrl}
                        />
                    </FullScreenModal>
                </>
            )}
            <NoInternetModal />

            <div
                className="flex w-full h-screen border-none"
                style={{
                    backgroundImage: `url(${EpubBg})`,
                }}
            >
                <div className="flex flex-row w-full h-full justify-between">
                    <div
                        className={`flex flex-col h-full w-full ${
                            isopenToc ? '-z-10' : 'z-30'
                        }`}
                    >
                        <div className="flex flex-col h-full  w-full pt-[0.5rem] pl-[6rem] pr-[4rem]  overflow-y-auto custom-scrollbar">
                            <div
                                className={` w-full flex justify-between items-center mb-2 relative ${
                                    isopenToc ? '-z-10' : 'z-0'
                                }`}
                            >
                                <div className="flex items-center gap-2  ">
                                    <div className="bg-white p-2 rounded-[0.75rem] shadow-md w-12 ">
                                        <p
                                            style={{
                                                background:
                                                    'linear-gradient(90deg, #527FED 0%, #275BDD 100%)',
                                                WebkitTextFillColor:
                                                    'transparent',
                                                WebkitBackgroundClip: 'text',
                                            }}
                                        >
                                            <Tooltip
                                                title={'Table Of Content'}
                                                placement="bottom"
                                            >
                                                <button
                                                    onClick={TOCclickHandler}
                                                    className="-z-10"
                                                    data-testid="toc-open-button"
                                                >
                                                    TOC
                                                </button>
                                            </Tooltip>
                                        </p>
                                    </div>
                                    <p className="m-0 text-black w-[10.5rem] text-[0.8125rem]">
                                        {className} - {subjectName}
                                    </p>
                                </div>
                                <div className="absolute left-[50%] translate-x-[-50%] -z-10 ">
                                    <ToggleComponent />
                                </div>

                                {activeTab === 'assets' ? (
                                    <Select
                                        options={options}
                                        value={selectedResType}
                                        onChange={handleClassChange}
                                        placeholder={selectedResType}
                                        className={`ml-[1.5rem] w-[10rem]`}
                                    />
                                ) : (
                                    <div className="absolute left-[70%] flex flex-row  text-nowrap space-x-[2.4rem] ">
                                        {(bookData?.dqb &&
                                            installationPackage !== 'server') ||
                                        showDQBPreference === 'Always' ? (
                                            <button
                                                className="flex flex-row items items-center justify-center gap-x-1"
                                                onClick={handleDQBClick}
                                            >
                                                <img src={DQBIcon} alt="DQB" />
                                                <p className=" text-md">DQB</p>
                                            </button>
                                        ) : null}
                                        {
                                        ctrbData?.data && Object.keys(ctrbData?.data).length > 0?
                                           <button 
                                                className="flex flex-row items items-center justify-center gap-x-1"
                                                onClick={CTRBClickHanlder}
                                            >
                                                    <img
                                                        src={EvaluateIcon}
                                                        alt="CTRBIcon"
                                                    />
                                                    <p className="text-md">CTRB</p>
                                            </button>
                                            :<></>
                                        }
                                        {evaluateData?.data &&
                                            Object.keys(evaluateData?.data)
                                                .length > 0 && (
                                                <button
                                                    className="flex flex-row items items-center justify-center gap-x-1"
                                                    onClick={
                                                        EvaluateClickHanlder
                                                    }
                                                >
                                                    <img
                                                        src={EvaluateIcon}
                                                        alt="EvaluateIcon"
                                                    />
                                                    <p className=" text-md">
                                                        Evaluate
                                                    </p>
                                                </button>
                                            )}
                                        {lessonPlan?.data &&
                                            Object.keys(lessonPlan?.data)
                                                .length > 0 && (
                                                <button
                                                    className="flex flex-row items items-center justify-center gap-x-1 hover:cursor-pointer"
                                                    onClick={LPclickHandler}
                                                >
                                                    <img
                                                        src={LPIcon}
                                                        alt="LPIcon"
                                                    />
                                                    <p className=" text-md">
                                                        Lesson Plan
                                                    </p>
                                                </button>
                                            )}
                                    </div>
                                )}
                            </div>

                            {activeTab === 'assets' ? (
                                <div className="pt-2">
                                    <ActivitiesComponent
                                        defaultRes={selectedResType}
                                    />
                                </div>
                            ) : (
                                <iframe
                                    id="book-iframe"
                                    ref={iframeRef}
                                    className="content-iframe w-full h-full transition transform duration-500 ease-in-out"
                                    src={iframeSrc}
                                    title={`Chapter ${currentPage}`}
                                    sandbox="allow-same-origin allow-scripts"
                                    onLoad={() => {
                                        setIsFrameLoaded(true);
                                    }}
                                />
                            )}
                        </div>
                    </div>
                    <div className="h-full">
                        {bookUri && activeTab !== 'assets' && (
                            <PageChangeButtons
                                offset={offset}
                                isPopupOpen={isPopupOpen}
                                close={closePopup}
                                bookUri={bookUri}
                                bookId={bookId}
                                currPage={currentPage.toString()}
                                // widgetsData={bookData?.widgets ?? null}
                                widgetsData={null}
                            />
                        )}
                    </div>
                </div>

                <div className="px-2 mr-3 flex flex-col items-center justify-center ">
                    {isPopupOpen && selectedActivity && (
                        <AssetViewer
                            isOpen={isPopupOpen}
                            onClose={closePopup}
                            type={selectedActivity.mediaType}
                            resId={selectedActivity.resId}
                            resPath={selectedActivity.href}
                            resTitle={selectedActivity.resTitle}
                            source={assetViewerSource}
                            bookUri={bookUri}
                            bookId={bookId}
                            pageNum={currentPage}
                            resExtenstion={
                                selectedActivity.href.split('.').pop() ?? ''
                            }
                            visualPageNum={currentPage - offset}
                            bookPageNum={currentPage}
                        />
                    )}
                    {isPopupOpen && handleARI.mediaType === 'articulate' && (
                        <FullScreenModal
                            title={handleARI.mediaType}
                            isOpen={isPopupOpen}
                            onClose={() => closePopup()}
                            footerButtons={[]}
                        >
                            <iframe
                                className="h-full w-full shadow-2xl custom-scrollbar"
                                src={handleARI.url}
                                sandbox="allow-same-origin allow-scripts"
                                style={{ borderRadius: '8px' }}
                            />
                        </FullScreenModal>
                    )}
                    {zoomData && (
                        <ZoomPopup
                            isOpen={isPopupOpen}
                            zoomData={zoomData}
                            zoomIds={ZoomPageData}
                            onClose={closePopup}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default BookReader;
